import { render, staticRenderFns } from "./OtrosDocumentos.vue?vue&type=template&id=746d79c4&scoped=true&"
import script from "./OtrosDocumentos.vue?vue&type=script&lang=js&"
export * from "./OtrosDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./OtrosDocumentos.vue?vue&type=style&index=0&id=746d79c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746d79c4",
  null
  
)

export default component.exports